cityWaterSave={
  
    "北京": 8315.0,
    "天津": 0.21,
    "河北": 8029.19,
    "石家庄市": 1494.6,
    "邯郸市": 1787.0,
    "武安市": 2841.0,
    "张家口市": 829.0,
    "沧州市": 420.0,
    "泊头市": 51.59,
    "衡水市": 199.0,
    "定州市": 407.0,
    "山西": 13774.0,
    "太原市": 168.0,
    "大同市": 7100.0,
    "阳泉市": 514.0,
    "长治市": 352.0,
    "晋城市": 95.0,
    "朔州市": 560.0,
    "晋中市": 3764.0,
    "河津市": 75.0,
    "忻州市": 72.0,
    "原平市": 20.0,
    "侯马市": 500.0,
    "霍州市": 260.0,
    "吕梁市": 144.0,
    "孝义市": 150.0,
    "内蒙古": 1288.0,
    "包头市": 450.0,
    "呼伦贝尔市": 0.0,
    "乌兰浩特市": 838.0,
    "辽宁": 24716.52,
    "沈阳市": 10517.0,
    "大连市": 2716.31,
    "瓦房店市": 108.0,
    "庄河市": 40.0,
    "海城市": 130.0,
    "抚顺市": 4420.0,
    "本溪市": 1431.0,
    "丹东市": 1862.0,
    "锦州市": 850.0,
    "北镇市": 37.0,
    "营口市": 1152.0,
    "大石桥市": 1.0,
    "辽阳市": 108.0,
    "盘锦市": 253.0,
    "铁岭市": 20.0,
    "调兵山市": 170.0,
    "朝阳市": 432.0,
    "北票市": 419.21,
    "凌源市": 50.0,
    "葫芦岛市": 0.0,
    "吉林": 12498.23,
    "长春市": 4.0,
    "榆树市": 30.0,
    "德惠市": 80.0,
    "吉林市": 6484.0,
    "桦甸市": 40.0,
    "四平市": 0.0,
    "双辽市": 0.0,
    "辽源市": 102.0,
    "通化市": 4468.0,
    "临江市": 64.0,
    "松原市": 203.0,
    "白城市": 125.07,
    "延吉市": 90.0,
    "图们市": 4.0,
    "敦化市": 323.0,
    "珲春市": 171.0,
    "龙井市": 98.0,
    "公主岭市": 103.81,
    "梅河口市": 108.0,
    "长白山保护开发区管理委员会": 0.35,
    "黑龙江": 13322.91,
    "哈尔滨市": 3142.0,
    "齐齐哈尔市": 776.91,
    "鹤岗市": 0.0,
    "大庆市": 3800.0,
    "伊春市": 521.0,
    "佳木斯市": 1178.0,
    "七台河市": 2920.0,
    "牡丹江市": 900.0,
    "绥芬河市": 0.0,
    "绥化市": 85.0,
    "上海": 20409.0,
    "江苏": 59621.4,
    "南京市": 5413.0,
    "无锡市": 2603.0,
    "江阴市": 638.0,
    "宜兴市": 332.62,
    "徐州市": 8220.0,
    "新沂市": 176.93,
    "邳州市": 1000.0,
    "常州市": 6821.0,
    "溧阳市": 7.0,
    "苏州市": 3738.0,
    "常熟市": 1714.0,
    "张家港市": 60.0,
    "昆山市": 610.0,
    "太仓市": 1106.0,
    "南通市": 803.08,
    "海安市": 102.0,
    "启东市": 115.0,
    "海门市": 95.0,
    "连云港市": 2607.0,
    "淮安市": 5300.0,
    "盐城市": 5700.0,
    "东台市": 43.27,
    "扬州市": 2535.0,
    "仪征市": 400.0,
    "高邮市": 267.5,
    "镇江市": 746.0,
    "丹阳市": 158.0,
    "扬中市": 100.0,
    "句容市": 101.0,
    "泰州市": 6934.0,
    "兴化市": 313.0,
    "宿迁市": 862.0,
    "浙江": 36302.0,
    "杭州市": 2928.0,
    "建德市": 210.0,
    "宁波市": 2824.0,
    "慈溪市": 1779.0,
    "温州市": 833.0,
    "嘉兴市": 960.0,
    "海宁市": 300.0,
    "湖州市": 310.12,
    "绍兴市": 8492.88,
    "诸暨市": 296.0,
    "嵊州市": 2599.0,
    "金华市": 414.0,
    "义乌市": 2030.0,
    "东阳市": 653.0,
    "永康市": 138.0,
    "衢州市": 8098.0,
    "江山市": 0.0,
    "舟山市": 470.0,
    "台州市": 2087.0,
    "玉环市": 120.0,
    "温岭市": 683.0,
    "丽水市": 77.0,
    "安徽": 15675.66,
    "合肥市": 1897.0,
    "蚌埠市": 1320.0,
    "淮南市": 690.0,
    "马鞍山市": 650.0,
    "淮北市": 2512.0,
    "黄山市": 5102.0,
    "滁州市": 200.0,
    "阜阳市": 427.0,
    "界首市": 190.0,
    "宿州市": 1530.0,
    "六安市": 320.0,
    "亳州市": 200.0,
    "池州市": 426.66,
    "宣城市": 211.0,
    "福建": 7137.0,
    "福州市": 720.0,
    "厦门市": 606.0,
    "三明市": 1205.0,
    "泉州市": 4595.0,
    "漳平市": 11.0,
    "江西": 906.0,
    "景德镇市": 635.0,
    "萍乡市": 15.0,
    "赣州市": 256.0,
    "丰城市": 0.0,
    "德兴市": 0.0,
    "山东": 39876.27,
    "济南市": 1560.0,
    "青岛市": 11875.0,
    "胶州市": 553.0,
    "平度市": 630.0,
    "莱西市": 210.0,
    "淄博市": 1225.0,
    "枣庄市": 1350.0,
    "滕州市": 182.0,
    "东营市": 4705.0,
    "烟台市": 1719.0,
    "龙口市": 293.0,
    "莱阳市": 1126.0,
    "蓬莱市": 136.0,
    "招远市": 886.0,
    "栖霞市": 66.0,
    "海阳市": 430.0,
    "潍坊市": 1631.0,
    "青州市": 650.0,
    "诸城市": 429.0,
    "寿光市": 409.0,
    "安丘市": 502.0,
    "昌邑市": 1670.0,
    "泰安市": 353.77,
    "新泰市": 510.0,
    "肥城市": 125.0,
    "威海市": 1156.0,
    "荣成市": 462.0,
    "乳山市": 174.0,
    "日照市": 594.0,
    "莱芜市": 987.0,
    "临沂市": 1724.5,
    "德州市": 253.0,
    "禹城市": 115.0,
    "滨州市": 730.0,
    "邹平市": 305.0,
    "菏泽市": 150.0,
    "河南": 24066.88,
    "郑州市": 6056.0,
    "巩义市": 44.0,
    "荥阳市": 818.0,
    "新密市": 21.0,
    "新郑市": 61.0,
    "登封市": 126.0,
    "开封市": 1132.34,
    "平顶山市": 3434.65,
    "舞钢市": 51.0,
    "汝州市": 120.0,
    "安阳市": 1485.0,
    "林州市": 60.1,
    "鹤壁市": 508.0,
    "新乡市": 3426.79,
    "濮阳市": 730.0,
    "许昌市": 37.0,
    "漯河市": 1390.0,
    "三门峡市": 358.0,
    "南阳市": 2698.0,
    "邓州市": 198.0,
    "周口市": 348.0,
    "驻马店市": 678.0,
    "济源市": 286.0,
    "湖北": 49308.83,
    "武汉市": 4000.0,
    "黄石市": 254.0,
    "宜昌市": 42981.0,
    "襄阳市": 340.0,
    "老河口市": 89.0,
    "宜城市": 85.83,
    "鄂州市": 0.0,
    "荆门市": 1198.0,
    "荆州市": 358.0,
    "广水市": 3.0,
    "湖南": 10190.0,
    "长沙市": 140.0,
    "株洲市": 2000.0,
    "邵阳市": 280.0,
    "武冈市": 0.0,
    "岳阳市": 2630.0,
    "常德市": 3233.0,
    "张家界市": 1865.0,
    "沅江市": 0.0,
    "永州市": 42.0,
    "涟源市": 0.0,
    "广东": 109105.53,
    "广州市": 30639.0,
    "深圳市": 38870.0,
    "珠海市": 1105.5,
    "汕头市": 148.0,
    "江门市": 2122.03,
    "湛江市": 175.0,
    "兴宁市": 0.0,
    "中山市": 194.0,
    "云浮市": 35852.0,
    "广西": 14417.0,
    "南宁市": 6831.0,
    "柳州市": 4797.0,
    "桂林市": 1000.0,
    "北海市": 488.0,
    "贵港市": 1301.0,
    "海南": 271.8,
    "三亚市": 129.1,
    "儋州市": 137.7,
    "万宁市": 5.0,
    "重庆": 161.0,
    "重庆市": 161.0,
    "四川": 14647.71,
    "成都市": 5500.93,
    "都江堰市": 16.0,
    "彭州市": 246.0,
    "自贡市": 750.0,
    "攀枝花市": 0.0,
    "泸州市": 83.0,
    "德阳市": 355.0,
    "广汉市": 400.0,
    "绵阳市": 2362.0,
    "广元市": 329.81,
    "遂宁市": 2481.97,
    "内江市": 320.0,
    "隆昌市": 210.0,
    "乐山市": 103.0,
    "南充市": 930.0,
    "眉山市": 325.0,
    "达州市": 235.0,
    "贵州": 4741.99,
    "贵阳市": 639.83,
    "清镇市": 3210.0,
    "安顺市": 572.0,
    "毕节市": 320.16,
    "云南": 3783.87,
    "昆明市": 3605.87,
    "玉溪市": 151.0,
    "蒙自市": 1.0,
    "文山市": 26.0,
    "香格里拉市": 0.0,
    "西藏": 0.0,
    "拉萨市": 0.0,
    "陕西": 1333.0,
    "西安市": 411.0,
    "宝鸡市": 303.0,
    "渭南市": 548.0,
    "韩城市": 6.0,
    "延安市": 65.0,
    "汉中市": 0.0,
    "甘肃": 7900.0,
    "兰州市": 7413.0,
    "金昌市": 423.0,
    "定西市": 64.0,
    "青海": 253.0,
    "西宁市": 253.0,
    "玉树市": 0.0,
    "宁夏": 1161.4,
    "银川市": 608.0,
    "石嘴山市": 479.0,
    "青铜峡市": 74.4,
    "新疆": 5224.0,
    "乌鲁木齐市": 5010.0,
    "吐鲁番市": 26.0,
    "哈密市": 80.0,
    "阿拉山口市": 0.0,
    "喀什市": 27.0,
    "和田市": 46.0,
    "伊宁市": 35.0,
    "可克达拉市": 0.0
}